import { useContext } from 'react';
import { Grid, Link, Typography } from '@material-ui/core';
import Moment from 'react-moment';
import { applicationContext, appUserContext } from 'helpers/services';
import { ticketContext } from '../../TicketContext';
import { ReferenceData } from 'helpers/enums';
import EditDetails from "./EditRequest";
import WarrantyIntegration from "./WarrantyIntegration";
import TicketsWithSerialNumber from "./TicketsWithSerialNumber";


let ProductInfo = () => {
    let { currentUser } = useContext(appUserContext);
    let { ticket, productSuppliers, ticketsWithSameSerialNumber } = useContext(ticketContext);
    let { referenceData } = useContext(applicationContext)

    return (
        <>
            <Grid container>
                <Grid item xs>
                    <Typography>{ticket.deliveryNote || '-'}</Typography>
                    <Typography variant="subtitle1">Delivery notes</Typography>
                </Grid>
                {currentUser?.canWorkOnAllTicket === true &&
                    <Grid item>
                        <EditDetails />
                    </Grid>
                }
            </Grid>
            <Grid container>
                <Grid item xs>
                    <Typography>
                        {ticket.invoiceDate ? <Moment date={ticket.invoiceDate} format="LL" /> : '-'}
                    </Typography>
                    <Typography variant="subtitle1">Invoice date</Typography>
                </Grid>
                <Grid item xs>
                    <Typography>{ticket.invoiceNumber || '-'}</Typography>
                    <Typography variant="subtitle1">Invoice number</Typography>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs>
                    {(ticket.productBrand || ticket.productDescription) &&
                        <Typography>
                            {ticket.productSKU}&nbsp;&middot;&nbsp;
                            {ticket.productBrand && `${ticket.productBrand} `}
                            {ticket.productDescription && `${ticket.productDescription} `}
                        </Typography>
                    }
                    {!ticket.productBrand && !ticket.productDescription &&
                        <Typography>{ticket.productSKU || '-'}</Typography>
                    }
                    <Typography variant="subtitle1">Product</Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography>{ticket.productQuantity || '-'}</Typography>
                    <Typography variant="subtitle1">Quantity</Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography>
                        {ticket.canSeeOnPIM
                            ? <Link target="_blank" href={`${process.env.REACT_APP_PIM_URL}/product/edit/${ticket.productSKU}/`}>Open product page</Link>
                            : 'Product not in PIM'
                        }
                    </Typography>
                    <Typography variant="subtitle1">PIM</Typography>
                </Grid>
                <Grid item xs={12}>
                    {ticket.productSupplierCode && ticket.productSupplierCode !== '' &&
                        <Typography>
                            {ticket.productSupplierCode} - {ticket.productSupplierName}
                        </Typography>
                    }
                    {productSuppliers.length > 0 && (!ticket.productSupplierCode || ticket.productSupplierCode === '') &&
                        <Typography>Multiple suppliers</Typography>
                    }
                    {productSuppliers.length <= 0 && (!ticket.productSupplierCode || ticket.productSupplierCode === '') &&
                        <Typography>-</Typography>
                    }
                    <Typography variant="subtitle1">Product supplier</Typography>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs>
                    <Typography>{ticket.productIsNew ? 'New' : 'Used'}</Typography>
                    <Typography variant="subtitle1">Condition</Typography>
                </Grid>
                <Grid item xs>
                    <Typography>
                        {ticket.purchaseCountry && ticket.purchaseCountry !== ''
                            ? referenceData.getByKey(ReferenceData.Country)?.values.getValueByKey(ticket.purchaseCountry)
                            : '-'
                        }
                    </Typography>
                    <Typography variant="subtitle1">Purchase country</Typography>
                </Grid>
                <Grid item xs>
                    <Typography>
                        {ticket.purchaseDate
                            ? <Moment date={ticket.purchaseDate} format='LL' />
                            : '-'
                        }
                    </Typography>
                    <Typography variant="subtitle1">Purchase date</Typography>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs>
                    <Typography>{ticket.productIsUnderWarranty ? 'Yes' : 'No'}</Typography>
                    <Typography variant="subtitle1">Is under warranty</Typography>
                </Grid>
                <Grid item xs>
                    <Typography>{ticket.hasPurchaseReceipt ? 'Yes' : 'No'}</Typography>
                    <Typography variant="subtitle1">Have you got end user purchase receipt?</Typography>
                </Grid>
                <Grid item xs>
                    <Typography>{ticket.canYouRepairProductYourself ? 'Yes' : 'No'}</Typography>
                    <Typography variant="subtitle1">Can you repair the product yourself?</Typography>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12}>
                    <Typography>{ticket.serialNumber || (ticket.serialNumberIsMissing ? 'Product has serial number but has not been provided' : '-')}</Typography>
                    <Typography variant="subtitle1">Serial number</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography>{ticket.suggestedAction || '-'}</Typography>
                    <Typography variant="subtitle1">Suggested action</Typography>
                </Grid>
            </Grid>

            <WarrantyIntegration />

            {ticketsWithSameSerialNumber.length > 0 &&
                <TicketsWithSerialNumber />
            }
        </>
    )
}

export default ProductInfo;